/* action type */
import type { Action } from '../../store/state/state-manager';

export const OPEN_BULK_ACTION = 'OPEN_BULK_ACTION';

/* action creator */
export const openBulkAction = (actionPayload: Action['payload']) => {
  return {
    type: OPEN_BULK_ACTION,
    payload: actionPayload
  };
};
